// Components==============
import {
    faCheck,
    faFlask,
    faFont,
    faRabbit,
    faSignOut,
    faTurtle,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logoutUser from 'actions/authentication/logout';
import updateUser from 'actions/authentication/updateUser';
import Avatar from 'components/UI/Avatar/Avatar';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { HomeContext } from 'screens/Home/Home';
// @ts-ignore
import packageJson from '../../../../../../../package.json';
import { MenuContext } from '../../Menu';
import Popup from '../Popup/Popup';
import './Cog.module.scss';
import TextBlock from './TextBlock/TextBlock';

// buildings
// =========================

export default function Cog() {
    const { select, selected, setMenuPointer, setSelected } = useContext(
        MenuContext
    );

    const history = useHistory();

    const dispatch = useDispatch();
    const user = useSelector(
        (state: ReduxStore) => state?.authentication?.user
    );

    const { setWelcomeY, welcomeSequence } = useContext(HomeContext);

    const [speakingRate, setSpeakingRate] = useState(
        parseFloat(user?.speaking_rate || '1')
    );

    const [currentPassword, setCurrentPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (welcomeSequence === 'settings') {
            setWelcomeY(`${ref?.current?.offsetTop}px`);
        }
    }, [welcomeSequence]);

    function handleSpeakingRateChange(e: React.ChangeEvent<HTMLInputElement>) {
        setSpeakingRate(parseInt(e.target.value) / 100);
    }

    function handleChangePassword() {
        if (!password) return;
        if (password !== confirmPassword) return;
        dispatch(
            updateUser({ password, confirmPassword, currentPassword })
            // @ts-ignore
        ).then(() => {
            setCurrentPassword('');
            setPassword('');
            setConfirmPassword('');
        });
    }

    useEffect(() => {
        console.log(user, 'user');
    }, [user]);

    return (
        <div styleName="wrapper" ref={ref}>
            <button
                onClick={(e) => {
                    select('cog');
                    setMenuPointer(e);
                }}
                type="button"
            >
                <img
                    alt="city icon"
                    src={`/images/menu/icon-cog${
                        selected === 'cog' ? '-active' : ''
                    }.svg`}
                />
            </button>
            {selected === 'cog' && (
                <Popup>
                    <div styleName="popup">
                        <p styleName="version">
                            Versie nr: {packageJson.version}
                        </p>
                        <div styleName="container1">
                            <Avatar />
                            <div styleName="right">
                                <p>
                                    <b>{user?.name}</b>
                                </p>
                                <div styleName="button-wrapper">
                                    <CircleButton
                                        onClick={() => {
                                            setSelected('initial');
                                            history.push('/test-pagina');
                                        }}
                                        color="light-grey"
                                    >
                                        <FontAwesomeIcon icon={faFlask} />
                                    </CircleButton>
                                    <CircleButton
                                        onClick={() => {
                                            dispatch(logoutUser());
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faSignOut} />
                                    </CircleButton>
                                </div>
                            </div>
                        </div>
                        <div styleName="change-password">
                            <p>
                                <b>Wachtwoord wijzigen</b>
                            </p>
                            <input
                                placeholder="Huidige wachtwoord"
                                type="password"
                                value={currentPassword}
                                onChange={(e) =>
                                    setCurrentPassword(e.target.value)
                                }
                            />
                            <input
                                name="new-password"
                                placeholder="wachtwoord"
                                autoComplete="new-password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <div styleName="repeat-password">
                                <input
                                    name="new-password-confirmation"
                                    placeholder="herhaal wachtwoord"
                                    type="password"
                                    autoComplete="new-password"
                                    value={confirmPassword}
                                    onChange={(e) =>
                                        setConfirmPassword(e.target.value)
                                    }
                                />
                                <CircleButton
                                    onClick={handleChangePassword}
                                    color={
                                        !confirmPassword ||
                                        password !== confirmPassword
                                            ? 'grey'
                                            : 'blue'
                                    }
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </CircleButton>
                            </div>
                        </div>
                        <div styleName="preferences">
                            <h3>Voorkeurs instellingen</h3>
                            <p styleName="description">
                                Wat een moeilijk woord. Je kunt hier instellen
                                hoe je het makkelijkst leest.
                            </p>
                            <p styleName="title ">
                                <b>Animatie</b>
                            </p>
                            <div styleName="flex">
                                <p>Achtergrond animaties</p>
                                <select
                                    value={user?.use_animations ? '1' : '0'}
                                    name="font"
                                    id="font"
                                    onChange={(e) =>
                                        dispatch(
                                            updateUser({
                                                use_animations:
                                                    parseInt(e.target.value) ===
                                                    1,
                                            })
                                        ).then(() => window.location.reload())
                                    }
                                >
                                    <option styleName="regular" value="1">
                                        Aan
                                    </option>
                                    <option value="0">Uit</option>
                                </select>
                            </div>
                            <p styleName="title ">
                                <b>Flitsprogramma</b>
                            </p>
                            <div styleName="flex">
                                <p>Voortgangsbalk</p>
                                <select
                                    value={user?.show_flash_timer ? '1' : '0'}
                                    name="font"
                                    id="font"
                                    onChange={(e) =>
                                        dispatch(
                                            updateUser({
                                                show_flash_timer:
                                                    parseInt(e.target.value) ===
                                                    1,
                                            })
                                        )
                                    }
                                >
                                    <option styleName="regular" value="1">
                                        Aan
                                    </option>
                                    <option value="0">Uit</option>
                                </select>
                            </div>
                            <p styleName="title ">
                                <b>Tekst</b>
                            </p>
                            <div styleName="flex">
                                <FontAwesomeIcon icon={faTurtle} />
                                <input
                                    styleName="slider"
                                    type="range"
                                    min="50"
                                    max="150"
                                    defaultValue={speakingRate * 100}
                                    onChange={handleSpeakingRateChange}
                                    onPointerUp={() =>
                                        dispatch(
                                            updateUser({
                                                speaking_rate: speakingRate,
                                            })
                                        )
                                    }
                                />
                                <FontAwesomeIcon icon={faRabbit} />
                            </div>
                            <div styleName="flex">
                                <FontAwesomeIcon icon={faFont} />
                                <select
                                    value={user?.font}
                                    name="font"
                                    id="font"
                                    onChange={(e) =>
                                        dispatch(
                                            updateUser({ font: e.target.value })
                                        )
                                    }
                                >
                                    <option styleName="regular" value="regular">
                                        Normaal
                                    </option>
                                    <option styleName="dyslexy" value="dyslexy">
                                        Dyslexie
                                    </option>
                                </select>
                            </div>
                            <p styleName="title ">
                                <b>Voorbeeld</b>
                            </p>
                            <TextBlock text="Dit is een voorbeeld tekst om je te helpen in het maken van je keuze. Hierin kan je het font zien en de audiosnelheid beluisteren die je in de input velden hierboven hebt geselecteerd." />
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    );
}
